export default __webpack_public_path__ + "static/media/xcult.dbc1c6af.jpg_medium";